/** 后端支持的批量任务整体状态。 */
export type BatchTaskOverallStatus =
    | 'READY'
    | 'RUNNING'
    | 'SUCCESS'
    | 'PARTIAL_SUCCESS'
    | 'FAILED';

/** 后端支持的单篇子任务状态。 */
export type BatchTaskItemStatus =
    | 'READY'
    | 'RUNNING'
    | 'SUCCESS'
    | 'FAILED'
    | 'SKIPPED';

/** 批量流程中可观测的执行阶段。 */
export type BatchTaskStage =
    | 'INIT'
    | 'CLAIM_DONE'
    | 'RECOMMEND_TS_DONE'
    | 'RECOMMEND_TS_CONFIRMED'
    | 'FIND_SECTIONS_DONE'
    | 'BLUE_DONE'
    | 'RED_DONE'
    | 'JUDGE_DONE';

export interface BatchTaskProgressRequest {
    batch_task_id: string;
}

export interface BatchTaskProgressItem {
    index: number;
    pn: string;
    patentId?: string | null;
    publication_number?: string | null;
    title?: string | null;
    applicant?: string | null;
    earliest_priority_date?: string | null;
    legal_status?: string | null;
    claim_number?: string | null;
    data_source?: string | null;
    sep_conclusion?: string | null;
    progress_percent: number;
    child_task_id: string;
    status: BatchTaskItemStatus;
    stage: BatchTaskStage;
    message?: string | null;
    started_at?: number | null;
    finished_at?: number | null;
}

export interface BatchTaskProgressData {
    batch_task_id: string;
    /** 批次创建时间，格式为 YYYY-MM-DD HH:mm:ss。 */
    created_at?: string | null;
    status: BatchTaskOverallStatus;
    total: number;
    success: number;
    failed: number;
    running: number;
    pending: number;
    message?: string | null;
    items: BatchTaskProgressItem[];
    updated_at?: number | null;
    finished_at?: number | null;
}

export interface BatchTaskProgressResponse {
    status: boolean;
    data?: BatchTaskProgressData;
    errorMsg?: string | null;
}

/** 启动批量任务中某个子任务重跑所需的稳定标识。 */
export interface BatchItemRerunStartRequest {
    batch_task_id: string;
    child_task_id: string;
}

/**
 * 重跑接口只确认任务已成功重新进入流程，不会创建或返回新的任务 ID。
 * 后续页面继续将请求中的 child_task_id 作为单条任务 task_id 使用。
 */
export interface BatchItemRerunStartResponse {
    status: boolean;
    error_code?: number;
    data?: Record<string, unknown>;
    errorMsg?: string | null;
}

export interface BatchTaskExportRequest {
    batch_task_id: string;
}

export type AiccSiteLanguage = 'CN' | 'EN';

/**
 * AICC 当前只接受中英文。繁体中文沿用中文结果，其余未支持语言安全降级到英文。
 */
export function toAiccSiteLanguage(locale: string): AiccSiteLanguage {
    return ['cn', 'tw'].includes(locale.toLowerCase()) ? 'CN' : 'EN';
}

export const BatchTaskApi = Symbol('BatchTaskApi');

/** 批量 CC 进度查询和整批导出接口。任务提交继续使用原有 /task/init。 */
export interface BatchTaskApi {
    getBatchProgress(request: BatchTaskProgressRequest): Promise<BatchTaskProgressResponse>;
    startBatchItemRerun(
        request: BatchItemRerunStartRequest
    ): Promise<BatchItemRerunStartResponse>;
    exportBatchResults(request: BatchTaskExportRequest): Promise<Blob>;
}
